// src/store/modules/system.js 或在主 store 文件中
import { getSystemInit } from '@/api/index'

const state = {
  systemConfig: {},
  isSystemInitialized: false,
  cartNum: 0
}

const mutations = {
  SET_SYSTEM_CONFIG(state, config) {
    state.systemConfig = config
    state.isSystemInitialized = true
  },
  SET_CART_NUM(state, num) {
    state.cartNum = num
  }
}

const actions = {
  // 获取系统配置
  async getSystemInit({ commit }) {
    try {
      const response = await getSystemInit()
      commit('SET_SYSTEM_CONFIG', response.data)
      return response
    } catch (error) {
      console.error('获取系统配置失败:', error)
      throw error
    }
  }
}

const getters = {
  systemConfig: state => state.systemConfig,
  isSystemInitialized: state => state.isSystemInitialized,
  cartNum: state => state.cartNum
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}